import { connect } from "react-redux"
import FileAttachment from "./fileUpload"
import {uploadAttachment} from "../../redux/actions/fileAttachment/fileAttachment.actions"


const mapStateToProps = (state)=>{
    return {
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        upload : (payload)=>{
            return dispatch(uploadAttachment(payload))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FileAttachment);